angular
    .module('access.Utils')
    .constant(
        'DefaultMainColor',
        [72, 117, 179] // We suppose that the default main color is blue (#4875B3)
    )
    .factory('MainColor', [
        'DefaultMainColor',
        function (DefaultMainColor) {
            var color;

            /**
             * This function is trying to obtain the main
             * color of the current color scheme in runtime.
             * The idea is quite simple: create a stub <a />
             * element, append it to the .header and get the color
             * property of computed CSS-styles.
             * @returns {Array} RGB representation of an obtained color
             *                  In case of fail returns DEFAULT_COLOR
             */
            function getMainColor() {
                var COLOR_REGEXP = /\(([^\(]+)\)/;
                var mainColorElement = angular
                    .element('<span id="main_color">main color</span>');
                var colorParsed = COLOR_REGEXP.exec(mainColorElement.appendTo('#body > .main').css('color'));
                mainColorElement.remove();

                if (colorParsed === null) {
                    return;
                }

                return colorParsed[1].split(',').map(function (item) {
                    return parseInt(item, 10);
                });
            }

            return {
                get: function () {
                    if (!angular.isUndefined(color)) {
                        return color;
                    }

                    return (color = getMainColor() || DefaultMainColor);
                }
            };
        }
    ]);
